var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ center: _vm.alignment === 'center' }},[_c('svg',{staticClass:"loading-icon"},[_c('circle',{attrs:{"cx":"50%","cy":"50%","r":"25","stroke":"#006199","stroke-width":"2","fill":"none"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }